'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { LEAVE_FEEDBACK_URL } from '../../constants/routes'

type Props = ConversationActionProps

const LeaveFeedback = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()
  const transactionId = conversation?.transactionId
  const oppositeUserId = conversation?.oppositeUser?.id

  const { relativeUrl } = useBrowserNavigation()

  if (!transactionId || !oppositeUserId) return null

  const feedbackFormUrl = urlWithParams(LEAVE_FEEDBACK_URL(oppositeUserId), {
    ref_url: relativeUrl,
    transaction_id: transactionId,
    referer: 'inbox',
  })

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={feedbackFormUrl}
      testId="leave-feedback-conversation-action"
    />
  )
}

export default LeaveFeedback
